module.exports = __webpack_public_path__ + "static/img/xi_4.e27204a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_4.jpg
// module id = hKXI
// module chunks = 1